import React, { FunctionComponent, ReactElement } from 'react';
import styled from '@emotion/styled';
import config from '@app/config';
import { useTranslation } from 'react-i18next';
import useInfraStores from '@app/hooks/useInfraStores';
import SupplierRegistrationMode from '@supplierRegistration/supplierRegistrationMode';

const HELP_CENTER_URL = 'https://help.nsknox.net/migration/knowledge';

const SupplierRegistrationFooter: FunctionComponent = () => {
  const { t } = useTranslation();
  const { languageStore } = useInfraStores<SupplierRegistrationMode>();

  const currentYear = new Date().getFullYear();

  const renderDot = (): ReactElement => {
    return <DotContainer>⬝</DotContainer>;
  };

  return (
    <Container direction={languageStore.isRTL ? 'rtl' : 'ltr'}>
      <FooterLeft>
        <LTRDiv>© {currentYear} nsKnox Technologies Ltd.</LTRDiv>
        {renderDot()} v{config.version}
      </FooterLeft>
      <FooterRight>
        <HelpCenterLink
          id='vldt-for-supp-footer-help-center'
          data-testid='vldt-for-supp-footer-help-center'
          href={HELP_CENTER_URL}
          target='_blank'
          rel='noreferrer'
        >
          {t('supplierValidation.helpCenter')}
        </HelpCenterLink>
      </FooterRight>
    </Container>
  );
};

export default SupplierRegistrationFooter;

const Container = styled.footer<{ direction: string }>`
  padding: 8px 37px 0;
  font-size: 13px;
  color: rgba(61, 68, 90, 0.8);
  background-color: transparent;
  font-weight: 200;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  border-top: #dadada solid 1px;
  direction: ${({ direction }): string => direction};
`;

const FooterLeft = styled.div`
  margin-top: 10px;
  margin-right: 10px;
  align-self: flex-start;
  justify-content: flex-start;
  display: flex;
  flex-direction: row;
  flex: 0 0 auto;
`;

const FooterRight = styled.div`
  align-self: flex-end;
  justify-content: flex-end;
  display: flex;
  flex-direction: row;
  flex: 0 0 auto;
  margin-top: 10px;
`;

const DotContainer = styled.div`
  margin: 0 13px;
`;

const HelpCenterLink = styled.a`
  font-size: 14px;
  color: var(--slate-gray-700);
  font-weight: bold;
  text-decoration: none !important;

  &:hover {
    color: var(--action-color);
  }
`;

const LTRDiv = styled.div`
  direction: ltr;
`;
